import React, { useState, useEffect } from "react";
import { successMsg } from "../SuccessHandler";
import { errorHandler } from "../ErrorHandler";

const VoidReasonModal = ({
  show,
  onHide,
  options,
  data,
  voidWagerList,
  session,
  openBetsInfo,
  getStatistics,
  setOpenBetsInfo,
}) => {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (show) {
      setComment("");
      setReason("");
      setError(false);
    }
  }, [show]);

  const handleConfirm = async () => {
    if (!reason) {
      setError(true);
      return;
    }

    const payload = {
      IDVoidReason: Number(reason),
      Comments: comment,
      WagerList: data || [],
    };

    const response = await voidWagerList(payload, session);

    if (!response.error && response.OutParams.Result === 0) {
      if (response?.List[0]?.OutParams?.ErrMsg) {
        errorHandler(response?.List[0]?.OutParams?.ErrMsg);
        return;
      }
      const ticketNumber = Array.isArray(data) ? data[0] : data;

      const updatedItems = openBetsInfo.filter(
        (ticket) => ticket.TicketNumber !== ticketNumber
      );
      setOpenBetsInfo(updatedItems);
      successMsg("Race Ticket #" + data + " voided");
      getStatistics();
    }

    onHide();
  };

  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header headerModals">
            <h5 className="modal-title">Void Ticket</h5>
            <button type="button" className="close" onClick={onHide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="reasonSelect">Reason</label>
              <select
                id="reasonSelect"
                className={`form-control ${error ? "is-invalid" : ""}`}
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value);
                  setError(false);
                }}
              >
                <option value="" disabled>
                  Select a Reason
                </option>
                {options.map((opt, index) => (
                  <option key={opt.ID ?? index} value={opt.ID}>
                    {opt.Description}
                  </option>
                ))}
              </select>
              {error && (
                <div className="invalid-feedback">Please select a reason</div>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="reasonComment">Comment</label>
              <textarea
                id="reasonComment"
                className="form-control"
                rows="2"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                maxLength={50}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleConfirm}
            >
              Void Ticket
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onHide}
            >
              Close
            </button>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: -1 }}></div>
    </div>
  );
};

export default VoidReasonModal;
